/**
 * 联系人信息
 * @author Created by jiamei.yao 2017/05/22
 */

'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image} from 'react-native';
import Icon from '../../../../components/Icon'
import styles from './style';
import {scale, getScreenSize} from "../../../../common/utils";

class BaseInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            depCity, arrCity, depDate, depWeekDay,
            backDate, depWeekDayDesc,backWeekDayDesc,travelType
        } = this.props.data;
        const {subTitleTop, baseInfoStyle, baseInfoTextStyle, iconColor, isRank} = this.props.config || {};

        let normalLen = isRank || arrCity.length + depCity.length <= 7;
        const transformScale = getScreenSize().width < 360 ? styles.transformScale : {};
        return (
            <View style={[styles.cheapBaseInfo, baseInfoStyle]}>
                <View style={[styles.cheapCity, transformScale]}>
                    <Text
                        style={[styles.cheapCityText, normalLen ? {maxWidth: scale(70)} : {maxWidth: scale(42)}, baseInfoTextStyle]}
                        numberOfLines={1} ellipsizeMode={'tail'}
                    >{depCity}</Text>
                    {travelType === '1'
                    ? <Icon name='oneway' size={18} color={iconColor || '#333333'} style={{height: 18, lineHeight: 18}}/>
                    : <Icon name='roundTrip' size={18} color={iconColor || '#333333'} style={{height: 18, lineHeight: 18}}/>}
                    <Text
                        style={[styles.cheapCityText, baseInfoTextStyle, normalLen ? {maxWidth: scale(70)} : {}]}
                        numberOfLines={1} ellipsizeMode={'tail'}
                    >{arrCity}</Text>
                </View>

                <View style={[styles.cheapDateInfo, {marginTop: subTitleTop},transformScale]}>
                    <View style={[styles.cheapDate, styles.cheapGoDate]}>
                        <Text style={styles.cheapDateText}>{depDate}</Text>
                        <Text style={styles.cheapWeekText}>{travelType === '1' ? depWeekDay : depWeekDayDesc}</Text>
                    </View>
                    {
                        backDate && depWeekDayDesc && (
                            <View style={[styles.cheapDate, styles.cheapBackDate]}>
                                <Text style={styles.cheapDateText}>{backDate}</Text>
                                <Text style={styles.cheapWeekText}>{backWeekDayDesc}</Text>
                            </View>
                        )
                    }
                </View>
            </View>
        )
    }
}

export default BaseInfo;
